import { useEffect, type ReactNode } from 'react';
import { I18nextProvider, useTranslation } from 'react-i18next';
import { studentI18n, setStudentDocumentLang } from '@/i18n/studentI18n';
import type { StudentLocale } from '@/constants/studentLocale';

function AuthDocumentLang() {
  const { i18n } = useTranslation();
  useEffect(() => {
    const prev = document.documentElement.lang;
    const lng: StudentLocale = i18n.language === 'en' ? 'en' : 'es';
    setStudentDocumentLang(lng);
    return () => { document.documentElement.lang = prev; };
  }, [i18n.language]);
  return null;
}

export function AuthI18nLayout({ children }: { children: ReactNode }) {
  return (
    <I18nextProvider i18n={studentI18n}>
      <AuthDocumentLang />
      {children}
    </I18nextProvider>
  );
}
